import * as React from "react";

export interface PeekInContextValue {
  onClose: () => void;
  panelOpen: boolean;
  setPanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  panelId: string;
}

export const PeekInContext = React.createContext<PeekInContextValue | null>(
  null
);

export function usePeekInContext(): PeekInContextValue {
  const context = React.useContext(PeekInContext);
  if (!context) {
    throw new Error("PeekIn sub-components must be rendered inside <PeekIn>");
  }
  return context;
}
